import React from "react";
import "./style.css";

const GradientBackground = ({ children }) => {
  return <div className="main-gradient-background">{children}</div>;
};

export default GradientBackground;
